import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { StatusService } from '../../api';

export const getStati = () => async (dispatch: Dispatch<ReduxAction>) => {
  new StatusService().getAllStati().then(result => {
    dispatch({
      type: ActionTypes.GET_ALL_STATI,
      payload: result.data,
    });
  });
};
